/**
 * Fime – Customer Journey Section
 *
 * Desktop (xl+): hover-follow sliding content panel under a row of
 * expanding circles. Mobile/tablet (<xl): Embla carousel with
 * autoplay + dot sync.
 *
 * Converted from a CDN-script version (global EmblaCarousel /
 * EmblaCarouselAutoplay) to proper ES module imports for our esbuild
 * pipeline. Interaction logic is otherwise unchanged.
 */

import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

// ── 1. Desktop: single sliding panel that follows the active circle ────────
const journeyCircleItems = document.querySelectorAll('.journey-circle-item');
const journeyActivePanel = document.getElementById('journey-active-panel');
const journeyActiveTitleEl = document.getElementById('journey-active-title');
const journeyActiveTextEl = document.getElementById('journey-active-text');

// Fixed design values — match the CSS exactly. Every non-active column is
// always 136px (only the currently active one is 240px), so the panel's
// left offset is simply index * (136 + gap), regardless of which column
// is active. No DOM measurement needed — keeps positioning pixel-exact.
const JOURNEY_NORMAL_WIDTH = 136;
const JOURNEY_GAP = 24;

let journeyActiveIndex = 0;

function setActiveCircle(index) {
	journeyCircleItems.forEach(function (item) {
		item.classList.toggle('is-active', Number(item.dataset.index) === index);
	});
}

/**
 * Slide the single content panel to sit under column `index`.
 * @param {number}  index
 * @param {boolean} animate - false on initial load (no transition jump)
 */
function positionJourneyPanel(index, animate) {
	if (!journeyActivePanel) return;
	const targetX = index * (JOURNEY_NORMAL_WIDTH + JOURNEY_GAP);

	journeyActivePanel.style.transition = animate
		? 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)'
		: 'none';
	journeyActivePanel.style.transform = 'translateX(' + targetX + 'px)';
}

function updateJourneyContent(item) {
	if (!journeyActiveTitleEl || !journeyActiveTextEl) return;

	// Quick fade-out, swap text, fade-in — avoids an abrupt text jump
	// while the panel slides horizontally to its new column.
	journeyActiveTitleEl.style.opacity = '0';
	journeyActiveTextEl.style.opacity = '0';

	setTimeout(function () {
                const titleSrc = item.querySelector('.journey-circle-title-src');
                const textSrc = item.querySelector('.journey-circle-text-src');
                journeyActiveTitleEl.textContent = titleSrc ? titleSrc.textContent : '';
                journeyActiveTextEl.textContent = textSrc ? textSrc.textContent : '';
                journeyActiveTitleEl.style.opacity = '1';
                journeyActiveTextEl.style.opacity = '1';
        }, 120);
}

journeyCircleItems.forEach(function (item) {
	item.addEventListener('mouseenter', function () {
		const index = Number(item.dataset.index);
		if (index === journeyActiveIndex) return;

		setActiveCircle(index);
		updateJourneyContent(item);
		positionJourneyPanel(index, true);
		journeyActiveIndex = index;
	});
});

// Initial placement — no animation on first paint.
positionJourneyPanel(journeyActiveIndex, false);

// ── 2. Mobile: Embla Carousel with autoplay + dot sync ─────────────────────
const journeyEmblaNode = document.getElementById('journey-embla');

if (journeyEmblaNode) {
	const viewportNode = journeyEmblaNode.querySelector('.embla__viewport');
	const dots = document.querySelectorAll('.journey-dot');

	const journeyAutoplay = Autoplay({ delay: 4000, stopOnInteraction: false });

	const journeyEmblaApi = EmblaCarousel(
		viewportNode,
		{ loop: true, align: 'start', containScroll: 'trimSnaps' },
		[journeyAutoplay]
	);

	function updateJourneyDots() {
		const selectedIndex = journeyEmblaApi.selectedScrollSnap();
		dots.forEach(function (dot, i) {
			dot.classList.toggle('is-active', i === selectedIndex);
		});
	}

	journeyEmblaApi.on('select', updateJourneyDots);
	updateJourneyDots();

	dots.forEach(function (dot) {
		dot.addEventListener('click', function () {
			journeyEmblaApi.scrollTo(Number(dot.dataset.slide));
		});
	});
}
